module.exports = __webpack_public_path__ + "static/img/logo_white.6e90b1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_white.png
// module id = qgEL
// module chunks = 1